import React, { useState, useEffect, useRef, useMemo } from "react";
import styled, { keyframes, css } from "styled-components";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import temperatureLineIcon from "../../../../assets/images/weather_icon/temperature_line.png";
import windspeedLineIcon from "../../../../assets/images/weather_icon/windspeed_line.png";
import precipitationLineIcon from "../../../../assets/images/weather_icon/precipitation_line.png";
import humidityLineIcon from "../../../../assets/images/weather_icon/humidity_line.png";
import windspeedLineLightIcon from "../../../../assets/images/weather_icon/windspeed_line_light.png";
import precipitationLineLightIcon from "../../../../assets/images/weather_icon/precipitation_line_light.png";
import humidityLineLightIcon from "../../../../assets/images/weather_icon/humidity_line_light.png";
import autodisplayLogo from "../../../../assets/images/autodisplay_logo4.png";

import s30Icon from "../../../../assets/images/New_weather_icon/S30_W.png";
import s10Icon from "../../../../assets/images/New_weather_icon/S10_W.png";
import s40Icon from "../../../../assets/images/New_weather_icon/S40_W.png";
import s44Icon from "../../../../assets/images/New_weather_icon/S44_W.png";
import s45Icon from "../../../../assets/images/New_weather_icon/S45_W.png";
import s46Icon from "../../../../assets/images/New_weather_icon/S46_W.png";
import s47Icon from "../../../../assets/images/New_weather_icon/S47_W.png";
import s11Icon from "../../../../assets/images/New_weather_icon/S11_W.png";
import s12Icon from "../../../../assets/images/New_weather_icon/S12_W.png";
import s13Icon from "../../../../assets/images/New_weather_icon/S13_W.png";
import s14Icon from "../../../../assets/images/New_weather_icon/S14_W.png";
import s15Icon from "../../../../assets/images/New_weather_icon/S15_W.png";
import s16Icon from "../../../../assets/images/New_weather_icon/S16_W.png";
import s17Icon from "../../../../assets/images/New_weather_icon/S17_W.png";
import s31Icon from "../../../../assets/images/New_weather_icon/S31_W.png";
import s32Icon from "../../../../assets/images/New_weather_icon/S32_W.png";
import s33Icon from "../../../../assets/images/New_weather_icon/S33_W.png";
import s34Icon from "../../../../assets/images/New_weather_icon/S34_W.png";
import s35Icon from "../../../../assets/images/New_weather_icon/S35_W.png";
import s36Icon from "../../../../assets/images/New_weather_icon/S36_W.png";
import s37Icon from "../../../../assets/images/New_weather_icon/S37_W.png";
import s41Icon from "../../../../assets/images/New_weather_icon/S41_W.png";
import s42Icon from "../../../../assets/images/New_weather_icon/S42_W.png";
import s43Icon from "../../../../assets/images/New_weather_icon/S43_W.png";

import s30IconDark from "../../../../assets/images/New_weather_icon/S30_B.png";
import s10IconDark from "../../../../assets/images/New_weather_icon/S10_B.png";
import s40IconDark from "../../../../assets/images/New_weather_icon/S40_B.png";
import s44IconDark from "../../../../assets/images/New_weather_icon/S44_B.png";
import s45IconDark from "../../../../assets/images/New_weather_icon/S45_B.png";
import s46IconDark from "../../../../assets/images/New_weather_icon/S46_B.png";
import s47IconDark from "../../../../assets/images/New_weather_icon/S47_B.png";
import s11IconDark from "../../../../assets/images/New_weather_icon/S11_B.png";
import s12IconDark from "../../../../assets/images/New_weather_icon/S12_B.png";
import s13IconDark from "../../../../assets/images/New_weather_icon/S13_B.png";
import s14IconDark from "../../../../assets/images/New_weather_icon/S14_B.png";
import s15IconDark from "../../../../assets/images/New_weather_icon/S15_B.png";
import s16IconDark from "../../../../assets/images/New_weather_icon/S16_B.png";
import s17IconDark from "../../../../assets/images/New_weather_icon/S17_B.png";
import s31IconDark from "../../../../assets/images/New_weather_icon/S31_B.png";
import s32IconDark from "../../../../assets/images/New_weather_icon/S32_B.png";
import s33IconDark from "../../../../assets/images/New_weather_icon/S33_B.png";
import s34IconDark from "../../../../assets/images/New_weather_icon/S34_B.png";
import s35IconDark from "../../../../assets/images/New_weather_icon/S35_B.png";
import s36IconDark from "../../../../assets/images/New_weather_icon/S36_B.png";
import s37IconDark from "../../../../assets/images/New_weather_icon/S37_B.png";
import s41IconDark from "../../../../assets/images/New_weather_icon/S41_B.png";
import s42IconDark from "../../../../assets/images/New_weather_icon/S42_B.png";
import s43IconDark from "../../../../assets/images/New_weather_icon/S43_B.png";

import AtomsGaugeInfo from "../atoms/AtomsGaugeInfo";
import { useAtom } from "jotai";
import {
  AUTODISPLAY_INTERVER_TIME,
  AUTODISPLAY_REACT_STATE,
  AUTODISPLAY_DISPLAY_WIDTH,
  AUTODISPLAY_DISPLAY_HEIGHT,
  AUTODISPLAY_SELECTED_BACKGROUND,
} from "../../../AtomStates";

const marqueeAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% - 4em));
  }
`;

const thermoLineIcon = temperatureLineIcon;

const weatherIcons = {
  light: {
    S10: s10Icon,
    S11: s11Icon,
    S12: s12Icon,
    S13: s13Icon,
    S14: s14Icon,
    S15: s15Icon,
    S16: s16Icon,
    S17: s17Icon,
    S30: s30Icon,
    S31: s31Icon,
    S32: s32Icon,
    S33: s33Icon,
    S34: s34Icon,
    S35: s35Icon,
    S36: s36Icon,
    S37: s37Icon,
    S40: s40Icon,
    S41: s41Icon,
    S42: s42Icon,
    S43: s43Icon,
    S44: s44Icon,
    S45: s45Icon,
    S46: s46Icon,
    S47: s47Icon,
    '01d': s10Icon,
    '01n': s10Icon,
    '02d': s30Icon,
    '02n': s30Icon,
    '03d': s40Icon,
    '03n': s40Icon,
    '04d': s40Icon,
    '04n': s40Icon,
    '09d': s41Icon,
    '09n': s41Icon,
    '10d': s31Icon,
    '10n': s31Icon,
    '11d': s40Icon,
    '11n': s40Icon,
    '13d': s43Icon,
    '13n': s43Icon,
    '50d': s40Icon,
    '50n': s40Icon,
  },
  dark: {
    S10: s10IconDark,
    S11: s11IconDark,
    S12: s12IconDark,
    S13: s13IconDark,
    S14: s14IconDark,
    S15: s15IconDark,
    S16: s16IconDark,
    S17: s17IconDark,
    S30: s30IconDark,
    S31: s31IconDark,
    S32: s32IconDark,
    S33: s33IconDark,
    S34: s34IconDark,
    S35: s35IconDark,
    S36: s36IconDark,
    S37: s37IconDark,
    S40: s40IconDark,
    S41: s41IconDark,
    S42: s42IconDark,
    S43: s43IconDark,
    S44: s44IconDark,
    S45: s45IconDark,
    S46: s46IconDark,
    S47: s47IconDark,
    '01d': s10IconDark,
    '01n': s10IconDark,
    '02d': s30IconDark,
    '02n': s30IconDark,
    '03d': s40IconDark,
    '03n': s40IconDark,
    '04d': s40IconDark,
    '04n': s40IconDark,
    '09d': s41IconDark,
    '09n': s41IconDark,
    '10d': s31IconDark,
    '10n': s31IconDark,
    '11d': s40IconDark,
    '11n': s40IconDark,
    '13d': s43IconDark,
    '13n': s43IconDark,
    '50d': s40IconDark,
    '50n': s40IconDark,
  }
};

const getWeatherIconImage = (iconCode, themeMode = "light") => {
  const theme = weatherIcons[themeMode] || weatherIcons.light;
  return theme[iconCode] || (themeMode === "dark" ? s10IconDark : s10Icon);
};

const themeColors = {
  dark: {
    mainColor: "white",
    MainContainerBackgroundLinearGradient01: "rgba(0, 0, 0, 0.4)",
    MainContainerBackgroundLinearGradient02: "rgba(0, 0, 0, 0.4)",
    MainPanelBackgroundLinearGradient01: "rgba(0, 0, 0, 0.3)",
    MainPanelBackgroundLinearGradient02: "rgba(0, 0, 0, 0.5)",
    MainPanelBackgroundLinearGradient03: "rgba(0, 0, 0, 0.3)",
    MainPanelOutline: "rgba(255, 255, 255, 0.4)",
    WeatherPanelBackgroundLinearGradient01: "rgba(0, 0, 0, 0.3)",
    WeatherPanelBackgroundLinearGradient02: "rgba(0, 0, 0, 0.5)",
    WeatherPanelBackgroundLinearGradient03: "rgba(0, 0, 0, 0.3)",
    WeatherPanelOutline: "rgba(255, 255, 255, 0.4)",
    WeatherLabelColor: "rgba(255, 255, 255, 0.6)",
    bottomMessageBackground: "rgba(255, 255, 255, 0.2)",
  },
  light: {
    mainColor: "black",
    MainContainerBackgroundLinearGradient01: "rgba(255, 255, 255, 0.4)",
    MainContainerBackgroundLinearGradient02: "rgba(255, 255, 255, 0.4)",
    MainPanelBackgroundLinearGradient01: "rgba(255, 255, 255, 0.3)",
    MainPanelBackgroundLinearGradient02: "rgba(255, 255, 255, 0.5)",
    MainPanelBackgroundLinearGradient03: "rgba(255, 255, 255, 0.3)",
    MainPanelOutline: "rgba(255, 255, 255, 0.4)",
    WeatherPanelBackgroundLinearGradient01: "rgba(255, 255, 255, 0.3)",
    WeatherPanelBackgroundLinearGradient02: "rgba(255, 255, 255, 0.5)",
    WeatherPanelBackgroundLinearGradient03: "rgba(255, 255, 255, 0.3)",
    MainPanelOutline: "rgba(255, 255, 255, 0.4)",
    WeatherLabelColor: "rgba(0, 0, 0, 0.6)",
    bottomMessageBackground: "rgba(0, 0, 0, 0.2)",
  },
};

const getThemeColor = (colorName, themeMode = "dark") => {
  const theme = themeColors[themeMode] || themeColors.dark;
  return theme[colorName] || themeColors.dark[colorName];
};

const getWeatherThemeIcon = (iconType, themeMode = "dark") => {
  const weatherIcons = {
    dark: {
      windspeed: windspeedLineIcon,
      precipitation: precipitationLineIcon,
      humidity: humidityLineIcon,
    },
    light: {
      windspeed: windspeedLineLightIcon,
      precipitation: precipitationLineLightIcon,
      humidity: humidityLineLightIcon,
    },
  };

  const theme = weatherIcons[themeMode] || weatherIcons.dark;
  return theme[iconType] || weatherIcons.dark[iconType];
};

const OrganismDisplayViewLinkLotation = ({
  viewId,
  textData: initialTextData,
  sensorSerialData: initialSensorSerialData,
  locationData: initialLocationData,
  themeMode: initialThemeMode,
  weatherData: initialWeatherData,
  sensorData: initialSensorData,
  backgroundImage,
}) => {
  const navigate = useNavigate();

  const [reactState] = useAtom(AUTODISPLAY_REACT_STATE);
  const [displayWidth] = useAtom(AUTODISPLAY_DISPLAY_WIDTH);
  const [displayHeight] = useAtom(AUTODISPLAY_DISPLAY_HEIGHT);
  const [selectedBackgroundIndex, setSelectedBackgroundIndex] = useAtom(
    AUTODISPLAY_SELECTED_BACKGROUND
  );

  const isFixedMode =
    reactState === "fixed" && displayWidth > 0 && displayHeight > 0;

  const [orientation, setOrientation] = useState("landscape");
  const [isWider, setIsWider] = useState(false);
  const [isTaller, setIsTaller] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());

  const [isTextOverflowing, setIsTextOverflowing] = useState(false);
  const messageContainerRef = useRef(null);
  const messageTextRef = useRef(null);

  const [textData, setTextData] = useState(initialTextData || "Loading...");
  const [sensorSerialData, setSensorSerialData] = useState(
    initialSensorSerialData
  );
  const [locationData, setLocationData] = useState(initialLocationData);
  const [themeMode, setThemeMode] = useState(initialThemeMode || "light");

  const [weatherData, setWeatherData] = useState(initialWeatherData || {
    temperature: "-",
    wind: "-",
    precipitation: "-",
    humidity: "-",
    pty: "-",
  });
  const [sensorData, setSensorData] = useState(initialSensorData || {
    ozone: "0",
    temperature: "23",
    humidity: "55",
    dust: "0",
    voc: "3",
    co2: "403",
  });
  const lastWeatherUpdateHourRef = useRef(null);

  const [weatherForecastData, setWeatherForecastData] = useState(initialWeatherData || {
    maxTemperature: "-",
    minTemperature: "-",
    sky: "-",
  });
  const [lastTempUpdateDate, setLastTempUpdateDate] = useState(null);

  const [autodisplayIntervalTime] = useAtom(AUTODISPLAY_INTERVER_TIME);

  useEffect(() => {
    setTextData(initialTextData || "");
  }, [initialTextData]);

  useEffect(() => {
    setSensorSerialData(initialSensorSerialData || null);
  }, [initialSensorSerialData]);

  useEffect(() => {
    if (initialSensorData) {
      setSensorData(initialSensorData);
    }
  }, [initialSensorData]);

  useEffect(() => {
    setLocationData(initialLocationData || null);
  }, [initialLocationData]);

  useEffect(() => {
    setThemeMode(initialThemeMode || "light");
  }, [initialThemeMode]);

  useEffect(() => {
    if (initialWeatherData) {
      setWeatherData(initialWeatherData);
      setWeatherForecastData((prev) => ({
        ...prev,
        minTemperature: initialWeatherData.minTemperature || prev.minTemperature,
        maxTemperature: initialWeatherData.maxTemperature || prev.maxTemperature,
        sky: initialWeatherData.sky || prev.sky,
        weatherIcon: initialWeatherData.weatherIcon || prev.weatherIcon,
        weatherMain: initialWeatherData.weatherMain || prev.weatherMain,
        pty: initialWeatherData.pty || prev.pty,
      }));
    }
  }, [initialWeatherData]);

  useEffect(() => {
    const checkOverflow = () => {
      const container = messageContainerRef.current;
      const text = messageTextRef.current;
      if (container && text) {
        const isOverflow = text.scrollWidth > container.clientWidth;
        if (isOverflow !== isTextOverflowing) {
          setIsTextOverflowing(isOverflow);
        }
      }
    };

    const timer = setTimeout(checkOverflow, 100);
    window.addEventListener("resize", checkOverflow);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", checkOverflow);
    };
  }, [textData, orientation, isWider, isTaller, isTextOverflowing]);

  useEffect(() => {
    if (
      weatherData.temperature &&
      (weatherForecastData.maxTemperature || weatherForecastData.minTemperature)
    ) {
      const currentTemp = parseFloat(weatherData.temperature);
      let shouldUpdate = false;
      let updateData = {};

      if (weatherForecastData.maxTemperature) {
        const maxTemp = parseFloat(weatherForecastData.maxTemperature);
        if (currentTemp > maxTemp) {
          updateData.maxTemperature = weatherData.temperature;
          shouldUpdate = true;
        }
      }

      if (weatherForecastData.minTemperature) {
        const minTemp = parseFloat(weatherForecastData.minTemperature);
        if (currentTemp < minTemp) {
          updateData.minTemperature = weatherData.temperature;
          shouldUpdate = true;
        }
      }

      if (shouldUpdate) {
        setWeatherForecastData((prev) => ({
          ...prev,
          ...updateData,
        }));
      }
    }
  }, [
    weatherData.temperature,
    weatherForecastData.maxTemperature,
    weatherForecastData.minTemperature,
  ]);

  const locationKey = useMemo(() => {
    const x = locationData?.selectedDistricts?.x;
    const y = locationData?.selectedDistricts?.y;
    return x && y ? `${x},${y}` : null;
  }, [locationData?.selectedDistricts?.x, locationData?.selectedDistricts?.y]);

  useEffect(() => {
    const dateTimerId = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);

    return () => {
      clearInterval(dateTimerId);
    };
  }, []);

  useEffect(() => {
    if (reactState === "fixed" && displayWidth > 0 && displayHeight > 0) {
      const fixedRatio = displayWidth / displayHeight;
      setOrientation(fixedRatio > 1 ? "landscape" : "portrait");
      setIsWider(fixedRatio > 16 / 9);
      setIsTaller(fixedRatio < 9 / 16);
    }
  }, [reactState, displayWidth, displayHeight]);

  useEffect(() => {
    if (reactState === "active" || reactState === undefined) {
      const handleResize = () => {
        const currentRatio = window.innerWidth / window.innerHeight;
        setOrientation(currentRatio > 1 ? "landscape" : "portrait");
        setIsWider(currentRatio > 16 / 9);
        setIsTaller(currentRatio < 9 / 16);
      };

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const day = currentDate.getDate();
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");

  const getWeatherStatus = (weather) => {
    switch (weather) {
      case "1": return "맑음";
      case "3": return "구름 많음";
      case "4": return "흐림";
      case "Clear": return "맑음";
      case "Clouds": return "구름 많음";
      case "Rain": return "비";
      case "Drizzle": return "이슬비";
      case "Thunderstorm": return "뇌우";
      case "Snow": return "눈";
      case "Mist":
      case "Fog": return "안개";
      default:
        if (typeof weather === "string") {
          return weather;
        }
        return "-";
    }
  };

  const getWeatherIconCode = (skyCode, ptyCode) => {
    return `S${skyCode}${ptyCode}`;
  };

  const currentWeatherIcon = weatherForecastData.sky && weatherForecastData.pyt ? 
    getWeatherIconCode(
      weatherForecastData.sky,
      weatherData.pty
    ) : weatherForecastData.weatherIcon;

  const textContent =
    textData || "미리보기";

  return (
    <OuterWrapper>
    <MainContainer
      orientation={orientation}
      isFixedMode={isFixedMode}
      displayWidth={displayWidth}
      displayHeight={displayHeight}
      themeMode={themeMode}
      backgroundImage={backgroundImage}
    >
      <ContentWrapper orientation={orientation}>
        <MainPanel orientation={orientation} themeMode={themeMode}>
          <HeaderContainer orientation={orientation}>
            <TitleSection orientation={orientation}>
              <MainTitle orientation={orientation} themeMode={themeMode}>
                {sensorSerialData?.title || "Auto Display"}
              </MainTitle>
            </TitleSection>
            <DateTimeSection orientation={orientation}>
              <DateContainer>
                <DateRow>
                  <DateText orientation={orientation} themeMode={themeMode}>{month}월</DateText>
                  <DateText orientation={orientation} themeMode={themeMode}>{day}일</DateText>
                </DateRow>
                <TimeText orientation={orientation} themeMode={themeMode}>
                  {hours}:{minutes}
                </TimeText>
              </DateContainer>
              {orientation === "portrait" && (
                <TopLogo src={autodisplayLogo} alt="logo" />
              )}
            </DateTimeSection>            
          </HeaderContainer>

          <SensorGrid orientation={orientation}>
            <SensorItem>
              <GaugeWrapper orientation={orientation}>
                <AtomsGaugeInfo
                  value={
                    sensorData.temperature === "-" ? 0 : sensorData.temperature
                  }
                  unit="°C"
                  label="온도"
                  minValue={-10}
                  maxValue={100}
                  goodRange={[15, 32]}
                  normalRange={[-10, 14]}
                  showStatus={true}
                  themeMode={themeMode}
                  showGreenRange={true}
                />
              </GaugeWrapper>
            </SensorItem>
            <SensorSeparator orientation={orientation} themeMode={themeMode} />
            <SensorItem>
              <GaugeWrapper orientation={orientation}>
                <AtomsGaugeInfo
                  value={sensorData.ozone === "-" ? 0 : sensorData.ozone}
                  unit="ppm"
                  label="오존"
                  minValue={0}
                  maxValue={0.2}
                  goodRange={[0, 0.03]}
                  normalRange={[0.03, 0.06]}
                  showStatus={true}
                  themeMode={themeMode}
                  showGreenRange={true}
                />
              </GaugeWrapper>
            </SensorItem>
            <SensorSeparator orientation={orientation} themeMode={themeMode} />
            <SensorItem>
              <GaugeWrapper orientation={orientation}>
                <AtomsGaugeInfo
                  value={sensorData.humidity === "-" ? 0 : sensorData.humidity}
                  unit="%"
                  label="습도"
                  minValue={0}
                  maxValue={100}
                  goodRange={[40, 70]}
                  normalRange={[0, 39]}
                  showStatus={true}
                  themeMode={themeMode}
                  showGreenRange={true}
                />
              </GaugeWrapper>
            </SensorItem>
            <SensorSeparator orientation={orientation} themeMode={themeMode} />
            <SensorItem>
              <GaugeWrapper orientation={orientation}>
                <AtomsGaugeInfo
                  value={sensorData.dust === "-" ? 0 : sensorData.dust}
                  unit="㎍/㎥"
                  label="미세먼지"
                  minValue={0}
                  maxValue={150}
                  goodRange={[0, 30]}
                  normalRange={[31, 80]}
                  showStatus={true}
                  themeMode={themeMode}
                  showGreenRange={true}
                />
              </GaugeWrapper>
            </SensorItem>
            <SensorSeparator orientation={orientation} themeMode={themeMode} />
            <SensorItem>
              <GaugeWrapper orientation={orientation}>
                <AtomsGaugeInfo
                  value={sensorData.voc === "-" ? 0 : sensorData.voc}
                  unit="ppm"
                  label="VOC"
                  minValue={0}
                  maxValue={1000}
                  goodRange={[0, 200]}
                  normalRange={[201, 500]}
                  showStatus={true}
                  themeMode={themeMode}
                />
              </GaugeWrapper>
            </SensorItem>
            <SensorSeparator orientation={orientation} themeMode={themeMode} />
            <SensorItem>
              <GaugeWrapper orientation={orientation}>
                <AtomsGaugeInfo
                  value={sensorData.co2 === "-" ? 0 : sensorData.co2}
                  unit="ppm"
                  label="이산화탄소"
                  minValue={0}
                  maxValue={3000}
                  goodRange={[0, 800]}
                  normalRange={[801, 1500]}
                  showStatus={true}
                  themeMode={themeMode}
                  showGreenRange={true}
                />
              </GaugeWrapper>
            </SensorItem>
          </SensorGrid>
        </MainPanel>

        <WeatherPanel orientation={orientation} themeMode={themeMode}>
          {orientation === "landscape" ? (
            <>
              <WeatherInfoHeader orientation={orientation} themeMode={themeMode}>
                <WeatherInfoHeaderText orientation={orientation} themeMode={themeMode}>
                  {locationData?.selectedRegion && locationData?.selectedDistricts?.district
                    ? `${locationData.selectedRegion} ${locationData.selectedDistricts.district}`
                    : "위치 정보 없음"}
                </WeatherInfoHeaderText>
              </WeatherInfoHeader>
              <NewWeatherContentWrapper orientation={orientation}>
            <MainWeatherGroup orientation={orientation}>
              <MainWeatherIcon
                orientation={orientation}
                src={getWeatherIconImage(currentWeatherIcon, themeMode)}
                alt={getWeatherStatus(weatherForecastData.sky ? weatherForecastData.sky : weatherForecastData.weatherMain)}
              />
                  <WeatherInfoContainer orientation={orientation}>
                    <WeatherStatus orientation={orientation} themeMode={themeMode}>
                      {getWeatherStatus(weatherForecastData.sky ? weatherForecastData.sky : weatherForecastData.weatherMain)}
                    </WeatherStatus>
                    <MainTemperatureContainer orientation={orientation}>
                      <MainTemperatureNumber orientation={orientation} themeMode={themeMode}>
                        {weatherData.temperature}
                      </MainTemperatureNumber>
                      <MainTemperatureUnit orientation={orientation} themeMode={themeMode}>
                        °C
                      </MainTemperatureUnit>
                    </MainTemperatureContainer>
                  </WeatherInfoContainer>
                  <MinMaxTemperatureContainer orientation={orientation}>
                    <MinMaxTemperature orientation={orientation} themeMode={themeMode}>
                      최저 {weatherForecastData.minTemperature}°
                    </MinMaxTemperature>
                    <MinMaxTemperature orientation={orientation} themeMode={themeMode}>
                      최고 {weatherForecastData.maxTemperature}°
                    </MinMaxTemperature>
                  </MinMaxTemperatureContainer>
                </MainWeatherGroup>

                <WeatherDataGroup orientation={orientation}>
                  <WeatherDataItem orientation={orientation}>
                    <WeatherDataIconContainer orientation={orientation}>
                      <WeatherIconContainer orientation={orientation}>
                        <WeatherIcon
                          orientation={orientation}
                          src={getWeatherThemeIcon("windspeed", themeMode)}
                          alt="풍속"
                        />
                      </WeatherIconContainer>
                      <WeatherLabel orientation={orientation} themeMode={themeMode}>풍속</WeatherLabel>
                    </WeatherDataIconContainer>
                    <WeatherDataValueContainer orientation={orientation}>
                      <WeatherValueNumber orientation={orientation} themeMode={themeMode}>
                        {weatherData.wind}
                      </WeatherValueNumber>
                      <WeatherValueUnit orientation={orientation} themeMode={themeMode}>m/s</WeatherValueUnit>
                    </WeatherDataValueContainer>
                  </WeatherDataItem>

                  <WeatherDataItem orientation={orientation}>
                    <WeatherDataIconContainer orientation={orientation}>
                      <WeatherIconContainer orientation={orientation}>
                        <WeatherIcon
                          orientation={orientation}
                          src={getWeatherThemeIcon("precipitation", themeMode)}
                          alt="강수량"
                        />
                      </WeatherIconContainer>
                      <WeatherLabel orientation={orientation} themeMode={themeMode}>강수량</WeatherLabel>
                    </WeatherDataIconContainer>
                    <WeatherDataValueContainer orientation={orientation}>
                      <WeatherValueNumber orientation={orientation} themeMode={themeMode}>
                        {weatherData.precipitation}
                      </WeatherValueNumber>
                      <WeatherValueUnit orientation={orientation} themeMode={themeMode}>
                        mm/h
                      </WeatherValueUnit>
                    </WeatherDataValueContainer>
                  </WeatherDataItem>

                  <WeatherDataItem orientation={orientation}>
                    <WeatherDataIconContainer orientation={orientation}>
                      <WeatherIconContainer orientation={orientation}>
                        <WeatherIcon
                          orientation={orientation}
                          src={getWeatherThemeIcon("humidity", themeMode)}
                          alt="습도"
                        />
                      </WeatherIconContainer>
                      <WeatherLabel orientation={orientation} themeMode={themeMode}>습도</WeatherLabel>
                    </WeatherDataIconContainer>
                    <WeatherDataValueContainer orientation={orientation}>
                      <WeatherValueNumber orientation={orientation} themeMode={themeMode}>
                        {weatherData.humidity}
                      </WeatherValueNumber>
                      <WeatherValueUnit orientation={orientation} themeMode={themeMode}>%</WeatherValueUnit>
                    </WeatherDataValueContainer>
                  </WeatherDataItem>
                </WeatherDataGroup>
              </NewWeatherContentWrapper>
            </>
          ) : (
            <PortraitWeatherLayout>
              <PortraitWeatherTitle orientation={orientation} themeMode={themeMode}>
                오늘의 날씨는?
              </PortraitWeatherTitle>
              
              <PortraitTopSection>
                <PortraitIconStatusGroup>
                  <MainWeatherIcon
                    orientation={orientation}
                    src={getWeatherIconImage(currentWeatherIcon, themeMode)}
                    alt={getWeatherStatus(weatherForecastData.sky ? weatherForecastData.sky : weatherForecastData.weatherMain)}
                  />
                  <WeatherStatus orientation={orientation} themeMode={themeMode}>
                    {getWeatherStatus(weatherForecastData.sky ? weatherForecastData.sky : weatherForecastData.weatherMain)}
                  </WeatherStatus>
                </PortraitIconStatusGroup>
                
                <PortraitMainTemperature orientation={orientation}>
                  <PortraitTemperatureNumber orientation={orientation} themeMode={themeMode}>
                    {weatherData.temperature}
                  </PortraitTemperatureNumber>
                  <PortraitTemperatureUnit orientation={orientation} themeMode={themeMode}>
                    °C
                  </PortraitTemperatureUnit>
                </PortraitMainTemperature>
                
                <PortraitLocationTempGroup>
                <PortraitMinMaxRow orientation={orientation}>
                  <MinMaxTemperature orientation={orientation} themeMode={themeMode}>
                    최저 {weatherForecastData.minTemperature}°
                  </MinMaxTemperature>

                  <VerticalDivider themeMode={themeMode} $height="22px" />

                  <MinMaxTemperature orientation={orientation} themeMode={themeMode}>
                      최고 {weatherForecastData.maxTemperature}°
                    </MinMaxTemperature>
                  </PortraitMinMaxRow>
                  <PortraitLocationText orientation={orientation} themeMode={themeMode}>
                    {locationData?.selectedRegion && locationData?.selectedDistricts?.district
                      ? `${locationData.selectedRegion} ${locationData.selectedDistricts.district}`
                      : "위치 정보 없음"}
                  </PortraitLocationText>
                </PortraitLocationTempGroup>
              </PortraitTopSection>
              
              <PortraitBottomSection>
                <PortraitWeatherDataItem orientation={orientation}>
                  <WeatherIconContainer orientation={orientation}>
                    <WeatherIcon
                      orientation={orientation}
                      src={getWeatherThemeIcon("windspeed", themeMode)}
                      alt="풍속"
                    />
                  </WeatherIconContainer>
                  <WeatherLabel orientation={orientation} themeMode={themeMode}>풍속</WeatherLabel>
                  <PortraitWeatherValue orientation={orientation}>
                    <WeatherValueNumber orientation={orientation} themeMode={themeMode}>
                      {weatherData.wind}
                    </WeatherValueNumber>
                    <WeatherValueUnit orientation={orientation} themeMode={themeMode}>m/s</WeatherValueUnit>
                  </PortraitWeatherValue>
                </PortraitWeatherDataItem>

                <VerticalDivider themeMode={themeMode} $height="32px" />

                <PortraitWeatherDataItem orientation={orientation}>
                  <WeatherIconContainer orientation={orientation}>
                    <WeatherIcon
                      orientation={orientation}
                      src={getWeatherThemeIcon("precipitation", themeMode)}
                      alt="강수량"
                    />
                  </WeatherIconContainer>
                  <WeatherLabel orientation={orientation} themeMode={themeMode}>강수량</WeatherLabel>
                  <PortraitWeatherValue orientation={orientation}>
                    <WeatherValueNumber orientation={orientation} themeMode={themeMode}>
                      {weatherData.precipitation}
                    </WeatherValueNumber>
                    <WeatherValueUnit orientation={orientation} themeMode={themeMode}>mm/h</WeatherValueUnit>
                  </PortraitWeatherValue>
                </PortraitWeatherDataItem>

                <VerticalDivider themeMode={themeMode} $height="32px" />

                <PortraitWeatherDataItem orientation={orientation}>
                  <WeatherIconContainer orientation={orientation}>
                    <WeatherIcon
                      orientation={orientation}
                      src={getWeatherThemeIcon("humidity", themeMode)}
                      alt="습도"
                    />
                  </WeatherIconContainer>
                  <WeatherLabel orientation={orientation} themeMode={themeMode}>습도</WeatherLabel>
                  <PortraitWeatherValue orientation={orientation}>
                    <WeatherValueNumber orientation={orientation} themeMode={themeMode}>
                      {weatherData.humidity}
                    </WeatherValueNumber>
                    <WeatherValueUnit orientation={orientation} themeMode={themeMode}>%</WeatherValueUnit>
                  </PortraitWeatherValue>
                </PortraitWeatherDataItem>
              </PortraitBottomSection>
            </PortraitWeatherLayout>
          )}
        </WeatherPanel>

        <BottomMessage ref={messageContainerRef} themeMode={themeMode} orientation={orientation}>
          <MessageTextContainer>
            <MessageText
              ref={messageTextRef}
              isOverflowing={isTextOverflowing}
              data-text={textContent}
              orientation={orientation}
            >
              {textContent}
            </MessageText>
          </MessageTextContainer>
        </BottomMessage>
      </ContentWrapper>
    </MainContainer>
    </OuterWrapper>
  );
};

export default OrganismDisplayViewLinkLotation;

// Styled Components
const OuterWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
`;

const MainContainer = styled.div`
  width: ${({ orientation }) =>
    orientation === "landscape" ? "1920px" : "1080px"};
  height: ${({ orientation }) =>
    orientation === "landscape" ? "1080px" : "1920px"};
  flex-shrink: 0;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ backgroundImage }) =>
    !backgroundImage || backgroundImage === "none"
      ? "transparent"
      : backgroundImage
      ? `url(${backgroundImage}) center center`
      : "transparent"};
  background-size: cover;
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-family: Pretendard, Arial, sans-serif;
  box-sizing: border-box;

  padding: 48px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    padding: 16px 16px;
    align-items: flex-start;
  `}
`;

const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 0;

  --font-scaler: 19.2px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 24px;
  `}
`;

const MainPanel = styled.div`
  flex: 3.4;
  display: flex;
  flex-direction: column;
  padding: 30px;
  background: linear-gradient(
    136deg,
    ${({ themeMode }) =>
        getThemeColor("MainPanelBackgroundLinearGradient01", themeMode)}
      0%,
    ${({ themeMode }) =>
        getThemeColor("MainPanelBackgroundLinearGradient02", themeMode)}
      50%,
    ${({ themeMode }) =>
        getThemeColor("MainPanelBackgroundLinearGradient03", themeMode)}
      100%
  );
  border-radius: 20px;
  margin: 10px;
  outline: 3px
    ${({ themeMode }) => getThemeColor("MainPanelOutline", themeMode)} solid;
  outline-offset: -3px;
  backdrop-filter: blur(12px);
  min-height: 0;
  overflow: visible;
  flex-shrink: 1;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    padding: 15px 15px 5px 15px;
    margin: 5px;
    border-radius: 20px;
    flex: 2; /* 세로모드에서 비율 조정 */
  `}
`;

const HeaderContainer = styled.div`
  align-self: stretch;
  justify-content: space-between;
  align-items: flex-start;
  display: flex;
  width: 100%;
  max-width: 100%;
  flex-shrink: 0;
  min-height: 115.2px;
  margin-bottom: 24px;

  padding: 0;
  flex-direction: ${({ orientation }) =>
    orientation === "portrait" ? "column" : "row"};
  
  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    justify-content: flex-start;
    gap: 19.2px;
    margin-bottom: 16px;
  `}
`;

const TitleSection = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 9.6px;
  display: flex;
  padding: 38.4px 38.4px 0 38.4px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    order: 2;
    padding: 0 20px 0 20px;
    gap: 5px;
  `}
`;

const MainTitle = styled.h1`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: calc(2.5 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(3 * var(--font-scaler));
  `}
`;

const DateTimeSection = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: ${({ orientation }) =>
    orientation === "portrait" ? "flex-start" : "flex-end"};
  gap: 3.84px;
  display: flex;

  ${({ orientation }) =>
    orientation === "portrait"
      ? `
        order: 1;
        flex-direction: row; /* 가로 배치 */
        justify-content: flex-start; /* 좌측 정렬 */
        align-items: center; /* 수직 중앙 정렬 */
        width: 100%; /* 전체 너비 */
        padding: 20px 20px 0 20px;
        margin-top: 0;
        gap: 0;
      `
      : `
        padding: 38.4px 0 0 38.4px;
  `}
`;

const DateContainer = styled.div`
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  gap: 0;
  width: 100%;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    justify-content: flex-start;
    width: auto;
  `}
`;

const DateRow = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 13.44px;
  display: flex;
`;

const DateText = styled.span`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: calc(2.05 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 400;
  line-height: 1.2;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(2.3 * var(--font-scaler));
  `}
`;

const TimeText = styled.div`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: calc(2.05 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 400;
  line-height: 1.2;

  width: 200px;
  text-align: center;
  flex-shrink: 0;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    width: 150px;
    font-size: calc(2.3 * var(--font-scaler));
    margin-left: 15px; /* 날짜와 시간 사이 간격 */
    text-align: left;
  `}
`;

const SensorGrid = styled.div`
  display: grid;
  width: 100%;
  height: auto;
  flex: 1;
  padding: 0;
  justify-content: center;
  align-items: center;
  min-height: 0;
  flex-shrink: 1;

  ${({ orientation }) =>
    orientation === "portrait"
      ? `
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, auto);
    gap: 8px;
    justify-content: center;
    align-items: center;
    justify-items: center;
    margin: 10px auto 0 auto;
    place-items: center;

    > *:nth-child(1) { grid-column: 1; grid-row: 1; }
    > *:nth-child(2) { display: none; }
    > *:nth-child(3) { grid-column: 2; grid-row: 1; }
    > *:nth-child(4) { display: none; }
    > *:nth-child(5) { grid-column: 3; grid-row: 1; }
    > *:nth-child(6) { display: none; }
    > *:nth-child(7) { grid-column: 1; grid-row: 2; }
    > *:nth-child(8) { display: none; }
    > *:nth-child(9) { grid-column: 2; grid-row: 2; }
    > *:nth-child(10) { display: none; }
    > *:nth-child(11) { grid-column: 3; grid-row: 2; }
  `
      : `
    grid-template-columns: repeat(6, 1fr);
    gap: 16px;
    grid-template-rows: auto;
    place-items: stretch;

    > *:nth-child(1) { grid-column: 1; grid-row: 1; }
    > *:nth-child(2) { display: none; }
    > *:nth-child(3) { grid-column: 2; grid-row: 1; }
    > *:nth-child(4) { display: none; }
    > *:nth-child(5) { grid-column: 3; grid-row: 1; }
    > *:nth-child(6) { display: none; }
    > *:nth-child(7) { grid-column: 4; grid-row: 1; }
    > *:nth-child(8) { display: none; }
    > *:nth-child(9) { grid-column: 5; grid-row: 1; }
    > *:nth-child(10) { display: none; }
    > *:nth-child(11) { grid-column: 6; grid-row: 1; }
  `}
`;

const SensorItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  height: auto;
  padding: 4px;
  white-space: nowrap;
  text-align: center;
  box-sizing: border-box;
  min-height: 0;

  > * {
    align-self: center;
    text-align: center;
  }
`;

const WeatherPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: linear-gradient(
    136deg,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient01", themeMode)}
      0%,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient02", themeMode)}
      50%,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient03", themeMode)}
      100%
  );
  border-radius: 20px;
  margin: 10px;
  outline: 3px
    ${({ themeMode }) => getThemeColor("WeatherPanelOutline", themeMode)} solid;
  outline-offset: -3px;
  backdrop-filter: blur(12px);
  padding: 40px 60px 80px 40px;
  min-height: 0;
  overflow: hidden;

  flex-shrink: 1;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    border-radius: 20px;
    margin: 5px;
    padding: 15px;
  `}
`;

const WeatherInfoHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 0 0 52px 0;
  margin-bottom: 20px;
  min-height: 0;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    padding: 20px 20px 0 20px;
    margin-bottom: 12px;
  `}
`;

const WeatherInfoHeaderText = styled.div`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(1.8 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(2.2 * var(--font-scaler));
  `}
`;

const WeatherIcon = styled.img`
  width: 64px;
  height: 64px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    width: 64px;
    height: 64px;
  `}
`;

const WeatherIconContainer = styled.div`
  width: 64px;
  height: 64px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
  }

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    width: 64px;
    height: 64px;
  `}
`;

const WeatherLabel = styled.div`
  color: ${({ themeMode }) =>
    getThemeColor(
      "WeatherLabelColor",
      themeMode
    )};
  font-size: calc(1.6 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(1.8 * var(--font-scaler));
  `}
`;

const WeatherValueNumber = styled.span`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: calc(2.5 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 400;
  line-height: 1.2;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(2.0 * var(--font-scaler));
  `}
`;

const WeatherValueUnit = styled.span`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: calc(1.6 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 500;
  line-height: 1.2;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(1.6 * var(--font-scaler));
  `}
`;

const BottomMessage = styled.div`
  padding: 15px;
  background: linear-gradient(
    136deg,
    ${({ themeMode }) =>
        getThemeColor("MainPanelBackgroundLinearGradient01", themeMode)}
      0%,
    ${({ themeMode }) =>
        getThemeColor("MainPanelBackgroundLinearGradient02", themeMode)}
      50%,
    ${({ themeMode }) =>
        getThemeColor("MainPanelBackgroundLinearGradient03", themeMode)}
      100%
  );
  border-radius: 20px;
  outline: 3px
    ${({ themeMode }) => getThemeColor("MainPanelOutline", themeMode)} solid;
  outline-offset: -3px;
  backdrop-filter: blur(12px);
  display: flex;
  align-items: center;
  gap: 15px;
  flex-shrink: 0;

  margin: 10px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    padding: 8px;
    border-radius: 20px;
    gap: 8px;
    margin: 5px;
  `}
`;

const MessageIcon = styled.div`
  width: 28.8px;
  height: 28.8px;
  background: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  border-radius: 50%;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    width: 15px;
    height: 15px;
  `}
`;

const MessageTextContainer = styled.div`
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
`;

const MessageText = styled.div`
  font-size: calc(1.8 * var(--font-scaler));
  font-weight: 600;
  white-space: nowrap;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(2.5 * var(--font-scaler));
  `}

  ${({ isOverflowing }) =>
    isOverflowing
      ? css`
          display: inline-block;
          will-change: transform;
          animation: ${marqueeAnimation} 15s linear infinite;
          position: relative;

          &::after {
            content: attr(data-text);
            position: absolute;
            left: 100%;
            top: 0;
            padding-left: 4em;
            white-space: nowrap;
          }
        `
      : css`
          overflow: visible;
        `}
`;

const StyledLine653 = styled.div`
  width: 5px;
  height: 117px;
  opacity: 0.6;
  background: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  align-self: center;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    width: 6px;
    height: 130px;
  `}
`;

const SensorSeparator = ({ themeMode, orientation }) => {
  return <StyledLine653 themeMode={themeMode} orientation={orientation} />;
};

const GaugeWrapper = styled.div`
  width: 80%;
  height: 80%;
  max-width: 104px;
  max-height: 104px;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    transform: scale(1.5);
    transform-origin: center center;
  }

  ${({ orientation }) =>
    orientation === "portrait"
      ? `
    width: 70%;
    height: 70%;
    max-width: 50px;
    max-height: 50px;
    > * {
      transform: scale(1.8);
    }
  `
      : `
  `}
`;

const NewWeatherContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  ${({ orientation }) =>
    orientation === "landscape"
      ? `
    gap: 0;
    justify-content: space-between;
  `
      : `
    gap: 30px;
    justify-content: space-around;
  `}

  align-items: center;
  width: 100%;
  min-height: 0;
  flex-shrink: 1;
`;

const MainWeatherGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  justify-content: flex-start;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 15px;
    flex-direction: column; /* 세로 모드에서 위아래로 배치 */
  `}
`;

const WeatherDataGroup = styled.div`
  ${({ orientation }) =>
    orientation === "landscape"
      ? `
    display: contents;
  `
      : `
    display: flex;
    flex-direction: row;
    gap: 60px;
    justify-content: center;
    align-items: center;
  `}
`;

const MainWeatherIcon = styled.img`
  width: 140px;
  height: 140px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    width: 180px;
    height: 180px;
  `}
`;

const WeatherInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    flex-direction: row;
    gap: 20px;
    align-items: center;
    justify-content: center;
  `}
`;

const WeatherStatus = styled.div`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: calc(1.8 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 300;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(2.0 * var(--font-scaler));
  `}
`;

const MainTemperatureContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 2px;
  `}
`;

const MainTemperatureNumber = styled.span`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: calc(2.5 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 400;
  line-height: 1;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(2.5 * var(--font-scaler));
  `}
`;

const MainTemperatureUnit = styled.span`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: calc(2 * var(--font-scaler));
  font-family: pretendard;
  font-weight: 500;
  line-height: 1;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(2.4 * var(--font-scaler));
  `}
`;

const MinMaxTemperatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 2px;
  `}
`;

const MinMaxTemperature = styled.div`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: calc(1.8 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 400;
  white-space: nowrap;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(1.6 * var(--font-scaler));
  `}
`;

const WeatherDataItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: auto;
  padding: 8px;
  box-sizing: border-box;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 12px;
    padding: 4px;
    flex-direction: column; /* 세로 모드에서 아이콘과 텍스트 수직 배치 */
  `}
`;

const WeatherDataIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 4px;
  `}
`;

const WeatherDataValueContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 2px;
  `}
`;

const TopLogo = styled.img`
  height: 40px; /* 적절한 높이 설정 */
  width: auto;
  object-fit: contain;
`;

// Portrait 모드 전용 스타일 컴포넌트들
const PortraitWeatherLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  height: 100%;
  padding: 20px;
`;

const PortraitWeatherTitle = styled.div`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(2.5 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 500;
  line-height: 1.2;
  text-align: left;
`;

const PortraitTopSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 48px;
  align-items: flex-end;
  gap: 0px;
`;

const PortraitIconStatusGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding-left: 44px;
`;

const PortraitMainTemperature = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;
  padding-bottom: 12px;
`;

const PortraitTemperatureNumber = styled.span`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(7.5 * var(--font-scaler));
  font-family: pretendard;
  font-weight: 400;
  line-height: 1;
`;

const PortraitTemperatureUnit = styled.span`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(5 * var(--font-scaler));
  font-family: poppins;
  font-weight: 300;
  line-height: 1;
  padding-bottom: 4px;
`;

const PortraitLocationTempGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding-right: 32px;
  padding-bottom: 16px;
`;

const PortraitMinMaxRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;

const PortraitLocationText = styled.div`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(1.6 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 300;
  line-height: 1.2;
  white-space: nowrap;
`;

const PortraitBottomSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 30px;
  margin-top: 12px;
`;

const PortraitWeatherDataItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

const PortraitWeatherValue = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;
`;

const VerticalDivider = styled.div`
  width: 2px;
  height: ${({ $height }) => $height || "40px"};
  opacity: 0.35;
  background: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  flex-shrink: 0;
`;
